// import React, { useState, useEffect } from "react";
// import { Form, Typography, Row, Col, Radio, Select, Input, Button } from "antd";
// import { platformApi } from "../../../../../../api";
// import TenureTable from "../../TenureTable";

// const { Item } = Form;
// const { Text } = Typography;

// const PaymentForm = ({
//   form,
//   open,
//   editable,
//   data,
//   validityRef,
//   financer,
//   onPaymentDataChange,
// }) => {
//   const [financeType, setFinanceType] = useState("cash");
//   const [financerList, setFinancerList] = useState([]);
//   const [emiRows, setEmiRows] = useState([{ id: 1, tenure: null, emi: "" }]);
//   const [financerTenure, setFinancerTenure] = useState({ data: [] });
//   const [prefilledData, setPrefilledData] = useState(null); // Store prefilled data

//   const { getFieldDecorator, setFieldsValue, getFieldValue } = form;

//   useEffect(() => {
//     validityRef.current = () => {
//       return handleSubmit();
//     };
//     return () => {
//       validityRef.current = null;
//     };
//   });

//   console.log("payment form:", data);

//   // Load financer list first
//   useEffect(() => {
//     if (open) {
//       loadFinancerList();
//     }
//   }, [open]);

//   // Handle prefilling after financer list is loaded
//   useEffect(() => {
//     if (open && data && financerList.length > 0) {
//       console.log("PaymentForm data:", data);
//       console.log("Financer list loaded:", financerList.length);

//       // Check if financer exists to determine payment type (PRIORITY)
//       if (data.financer) {
//         // Finance payment mode
//         console.log("Setting finance type because financer exists");

//         setFinanceType("finance");

//         // Set form values
//         setFieldsValue({
//           financerId: data.financer.id,
//           downPayment: data.downPayment,
//         });

//         // Store prefilled data for reference
//         setPrefilledData({
//           financerId: data.financer.id,
//           downPayment: data.downPayment,
//         });

//         // Handle financerTenure data
//         if (data.financerTenure) {
//           try {
//             let tenureData;
//             if (typeof data.financerTenure === "string") {
//               tenureData = JSON.parse(data.financerTenure);
//             } else {
//               tenureData = data.financerTenure;
//             }

//             if (tenureData && tenureData.data) {
//               setFinancerTenure(tenureData);
//               const populatedRows = tenureData.data.map((item, index) => ({
//                 id: index + 1,
//                 tenure: item.tenure || "",
//                 emi: item.emi || "",
//               }));
//               setEmiRows(populatedRows);
//             }
//           } catch (error) {
//             console.error("Error parsing financerTenure:", error);
//             setFinancerTenure({ data: [] });
//             setEmiRows([{ id: 1, tenure: null, emi: "" }]);
//           }
//         }
//       } else {
//         // Cash payment mode - only if no financer exists
//         console.log("Setting cash type because no financer exists");

//         setFinanceType("cash");
//         setFieldsValue({
//           financerId: null,
//           downPayment: null,
//         });
//         setFinancerTenure({ data: [] });
//         setEmiRows([{ id: 1, tenure: null, emi: "" }]);

//         // Only check paymentDetails if no financer exists
//         if (data.paymentDetails) {
//           const {
//             paymentType,
//             financerId,
//             downPayment,
//             financerTenure: tenure,
//           } = data.paymentDetails;

//           if (paymentType) {
//             console.log("down:", downPayment);

//             setFinanceType(paymentType);
//             setFieldsValue({
//               financerId: financerId,
//               downPayment: downPayment,
//             });

//             // Store prefilled data for reference (this was missing!)
//             setPrefilledData({
//               financerId: financerId,
//               downPayment: downPayment,
//             });

//             if (tenure && tenure.data) {
//               setFinancerTenure(tenure);
//               const populatedRows = tenure.data.map((item, index) => ({
//                 id: index + 1,
//                 tenure: item.tenure || "",
//                 emi: item.emi || "",
//               }));
//               setEmiRows(populatedRows);
//             }
//           }
//         }
//       }
//     }
//   }, [open, data, financerList]);

//   const loadFinancerList = async () => {
//     try {
//       const result = await platformApi.get("/api/financer");
//       const { data } = result;
//       if (data.code === 200) {
//         const { response } = data;
//         setFinancerList(response.data);
//       }
//     } catch (error) {
//       console.error("Error loading financer list:", error);
//     }
//   };

//   const handleSubmit = () => {
//     let error;
//     form.validateFields((validationError) => {
//       error = validationError === null;
//       if (error) {
//         const paymentData = {
//           paymentType: financeType,
//           financerId:
//             financeType === "finance" ? getFieldValue("financerId") : null,
//           downPayment:
//             financeType === "finance"
//               ? Number(getFieldValue("downPayment"))
//               : null,
//           financerTenure:
//             financeType === "finance" ? financerTenure : { data: [] },
//         };

//         // Update the data object with payment details
//         data.paymentDetails = paymentData;

//         // Notify parent component about payment data change
//         if (onPaymentDataChange) {
//           onPaymentDataChange(paymentData);
//         }
//       }
//     });
//     return error;
//   };

//   const resetFinanceForm = () => {
//     setFieldsValue({
//       financerId: null,
//       downPayment: null,
//     });
//     setEmiRows([{ id: 1, tenure: null, emi: "" }]);
//     setFinancerTenure({ data: [] });
//   };

//   const handleFinanceData = (data) => {
//     setFinancerTenure(data);
//   };

//   return (
//     <Form>
//       <Row type="flex" justify="space-around">
//         <Col span={24}>
//           <Item label={<Text>Payment Type</Text>} colon={false}>
//             <Radio.Group
//               value={financeType}
//               onChange={(e) => {
//                 resetFinanceForm();
//                 setFinanceType(e.target.value);
//               }}
//               disabled={!editable}
//               buttonStyle="solid"
//             >
//               <Radio.Button value={"cash"}>Cash</Radio.Button>
//               <Radio.Button value={"finance"}>Finance</Radio.Button>
//             </Radio.Group>
//           </Item>
//         </Col>
//       </Row>

//       {financeType === "finance" && (
//         <>
//           <Row type="flex" justify="space-around">
//             <Col xs={24} md={11}>
//               <Item label={<Text>Financer Name</Text>} colon={false}>
//                 {getFieldDecorator("financerId", {
//                   initialValue: prefilledData?.financerId,
//                   rules: [
//                     {
//                       required: financeType === "finance",
//                       message: "Select Financer",
//                     },
//                   ],
//                 })(
//                   <Select
//                     showSearch
//                     showAction={["click", "focus"]}
//                     disabled={!editable || financeType === "cash"}
//                     placeholder="Select Financer"
//                   >
//                     {financerList.map((financer) => (
//                       <Select.Option key={financer.id} value={financer.id}>
//                         {financer.name}
//                       </Select.Option>
//                     ))}
//                   </Select>
//                 )}
//               </Item>
//             </Col>
//            <Col xs={24} md={11}>
//   <Item label={<Text>Down Payment</Text>} colon={false}>
//     {getFieldDecorator("downPayment", {
//       initialValue: prefilledData?.downPayment,
//       rules: [
//         {
//           required: financeType === "finance",
//           message: "Enter down payment",
//         },
//         {
//           validator: (rule, value, callback) => {
//             if (value && value <= 0) {
//               callback("Down payment must be greater than 0");
//             } else if (value && !Number.isInteger(Number(value))) {
//               callback("Down payment must be a whole number");
//             } else {
//               callback();
//             }
//           }
//         }
//       ],
//     })(
//       <Input
//         type="number"
//         placeholder="Enter down payment"
//         min="1"
//         step="1"
//         style={{ width: "100%" }}
//         disabled={!editable || financeType === "cash"}
//         onKeyDown={(e) => {
//           // Prevent 'e' character from being entered in number input
//           if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+' || e.key === '.') {
//             e.preventDefault();
//           }
//         }}
//       />
//     )}
//   </Item>
// </Col>
//           </Row>

//           <Row type="flex" justify="space-around">
//             <Col span={24}>
//               <Item label={<Text>Tenure & EMI Details</Text>} colon={false}>
//                 <TenureTable
//                   editable={editable}
//                   onDataChange={handleFinanceData}
//                   initialData={financerTenure}
//                   emiRows={emiRows}
//                   setEmiRows={setEmiRows}
//                 />
//               </Item>
//             </Col>
//           </Row>
//         </>
//       )}
//     </Form>
//   );
// };

// const WrappedPaymentForm = Form.create({ name: "payment_form" })(PaymentForm);

// export default WrappedPaymentForm;
import React, { useState, useEffect } from "react";
import { Form, Typography, Row, Col, Radio, Select, Input, Button } from "antd";
import { platformApi } from "../../../../../../api";
import TenureTable from "../../TenureTable";

const { Item } = Form;
const { Text } = Typography;

const PaymentForm = ({
  form,
  open,
  editable,
  data,
  validityRef,
  financer,
  onPaymentDataChange,
  vehicleTotal = 0, // ✅ ADD THIS PROP with default value
}) => {
  const [financeType, setFinanceType] = useState("cash");
  const [financerList, setFinancerList] = useState([]);
  const [emiRows, setEmiRows] = useState([{ id: 1, tenure: null, emi: "" }]);
  const [financerTenure, setFinancerTenure] = useState({ data: [] });
  const [prefilledData, setPrefilledData] = useState(null);
  const [maxDownPayment, setMaxDownPayment] = useState(0); // ✅ ADD THIS STATE

  const { getFieldDecorator, setFieldsValue, getFieldValue } = form;

  // ✅ ADD THIS EFFECT to update max down payment
  useEffect(() => {
    if (vehicleTotal && vehicleTotal > 0) {
      setMaxDownPayment(vehicleTotal);
    }
  }, [vehicleTotal]);

  useEffect(() => {
    validityRef.current = () => {
      return handleSubmit();
    };
    return () => {
      validityRef.current = null;
    };
  });

  console.log("payment form:", data);
  console.log("Vehicle Total:", vehicleTotal); // ✅ ADD FOR DEBUG
  console.log("Max Down Payment:", maxDownPayment); // ✅ ADD FOR DEBUG

  // Load financer list first
  useEffect(() => {
    if (open) {
      loadFinancerList();
    }
  }, [open]);

  // Handle prefilling after financer list is loaded
  useEffect(() => {
    if (open && data && financerList.length > 0) {
      console.log("PaymentForm data:", data);
      console.log("Financer list loaded:", financerList.length);

      // Check if financer exists to determine payment type (PRIORITY)
      if (data.financer) {
        // Finance payment mode
        console.log("Setting finance type because financer exists");

        setFinanceType("finance");

        // Set form values
        setFieldsValue({
          financerId: data.financer.id,
          downPayment: data.downPayment,
        });

        // Store prefilled data for reference
        setPrefilledData({
          financerId: data.financer.id,
          downPayment: data.downPayment,
        });

        // Handle financerTenure data
        if (data.financerTenure) {
          try {
            let tenureData;
            if (typeof data.financerTenure === "string") {
              tenureData = JSON.parse(data.financerTenure);
            } else {
              tenureData = data.financerTenure;
            }

            if (tenureData && tenureData.data) {
              setFinancerTenure(tenureData);
              const populatedRows = tenureData.data.map((item, index) => ({
                id: index + 1,
                tenure: item.tenure || "",
                emi: item.emi || "",
              }));
              setEmiRows(populatedRows);
            }
          } catch (error) {
            console.error("Error parsing financerTenure:", error);
            setFinancerTenure({ data: [] });
            setEmiRows([{ id: 1, tenure: null, emi: "" }]);
          }
        }
      } else {
        // Cash payment mode - only if no financer exists
        console.log("Setting cash type because no financer exists");

        setFinanceType("cash");
        setFieldsValue({
          financerId: null,
          downPayment: null,
        });
        setFinancerTenure({ data: [] });
        setEmiRows([{ id: 1, tenure: null, emi: "" }]);

        // Only check paymentDetails if no financer exists
        if (data.paymentDetails) {
          const {
            paymentType,
            financerId,
            downPayment,
            financerTenure: tenure,
          } = data.paymentDetails;

          if (paymentType) {
            console.log("down:", downPayment);

            setFinanceType(paymentType);
            setFieldsValue({
              financerId: financerId,
              downPayment: downPayment,
            });

            // Store prefilled data for reference
            setPrefilledData({
              financerId: financerId,
              downPayment: downPayment,
            });

            if (tenure && tenure.data) {
              setFinancerTenure(tenure);
              const populatedRows = tenure.data.map((item, index) => ({
                id: index + 1,
                tenure: item.tenure || "",
                emi: item.emi || "",
              }));
              setEmiRows(populatedRows);
            }
          }
        }
      }
    }
  }, [open, data, financerList]);

  const loadFinancerList = async () => {
    try {
      const result = await platformApi.get("/api/financer");
      const { data } = result;
      if (data.code === 200) {
        const { response } = data;
        setFinancerList(response.data);
      }
    } catch (error) {
      console.error("Error loading financer list:", error);
    }
  };

  const handleSubmit = () => {
    let error;
    form.validateFields((validationError) => {
      error = validationError === null;
      if (error) {
        const paymentData = {
          paymentType: financeType,
          financerId:
            financeType === "finance" ? getFieldValue("financerId") : null,
          downPayment:
            financeType === "finance"
              ? Number(getFieldValue("downPayment"))
              : null,
          financerTenure:
            financeType === "finance" ? financerTenure : { data: [] },
        };

        // Update the data object with payment details
        data.paymentDetails = paymentData;

        // Notify parent component about payment data change
        if (onPaymentDataChange) {
          onPaymentDataChange(paymentData);
        }
      }
    });
    return error;
  };

  const resetFinanceForm = () => {
    setFieldsValue({
      financerId: null,
      downPayment: null,
    });
    setEmiRows([{ id: 1, tenure: null, emi: "" }]);
    setFinancerTenure({ data: [] });
  };

  const handleFinanceData = (data) => {
    setFinancerTenure(data);
  };

  return (
    <Form>
      <Row type="flex" justify="space-around">
        <Col span={24}>
          <Item label={<Text>Payment Type</Text>} colon={false}>
            <Radio.Group
              value={financeType}
              onChange={(e) => {
                resetFinanceForm();
                setFinanceType(e.target.value);
              }}
              disabled={!editable}
              buttonStyle="solid"
            >
              <Radio.Button value={"cash"}>Cash</Radio.Button>
              <Radio.Button value={"finance"}>Finance</Radio.Button>
            </Radio.Group>
          </Item>
        </Col>
      </Row>

      {financeType === "finance" && (
        <>
          <Row type="flex" justify="space-around">
            <Col xs={24} md={11}>
              <Item label={<Text>Financer Name</Text>} colon={false}>
                {getFieldDecorator("financerId", {
                  initialValue: prefilledData?.financerId,
                  rules: [
                    {
                      required: financeType === "finance",
                      message: "Select Financer",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    showAction={["click", "focus"]}
                    disabled={!editable || financeType === "cash"}
                    placeholder="Select Financer"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    notFoundContent="No Data"
                  >
                    {financerList.map((financer) => (
                      <Select.Option key={financer.id} value={financer.id}>
                        {financer.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Item>
            </Col>
           <Col xs={24} md={11}>
              {/* ✅ UPDATED LABEL with max amount */}
              <Item 
                label={
                  <Text>
                    Down Payment 
                    {maxDownPayment > 0 && (
                      <span style={{ fontSize: '12px', color: '#888', marginLeft: '5px' }}>
                        (Max: ₹{maxDownPayment.toLocaleString()})
                      </span>
                    )}
                  </Text>
                } 
                colon={false}
              >
                {getFieldDecorator("downPayment", {
                  initialValue: prefilledData?.downPayment,
                  rules: [
                    {
                      required: financeType === "finance",
                      message: "Enter down payment",
                    },
                    {
                      validator: (rule, value, callback) => {
                        if (!value && financeType === "finance") {
                          callback("Down payment is required");
                          return;
                        }
                        
                        const numValue = Number(value);
                        
                        if (value && numValue <= 0) {
                          callback("Down payment must be greater than 0");
                        } else if (value && !Number.isInteger(numValue)) {
                          callback("Down payment must be a whole number");
                        } else if (value && maxDownPayment > 0 && numValue > maxDownPayment) {
                          callback(`Down payment cannot exceed total vehicle price of ₹${maxDownPayment.toLocaleString()}`);
                        } else {
                          callback();
                        }
                      }
                    }
                  ],
                })(
                  <Input
                    type="number"
                    placeholder={`Enter down payment (Max: ₹${maxDownPayment.toLocaleString()})`}
                    min="1"
                    max={maxDownPayment || undefined}
                    step="1"
                    style={{ width: "100%" }}
                    disabled={!editable || financeType === "cash"}
                    onKeyDown={(e) => {
                      // Prevent 'e' character from being entered in number input
                      if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+' || e.key === '.') {
                        e.preventDefault();
                      }
                    }}
                  />
                )}
              </Item>
            </Col>
          </Row>

          <Row type="flex" justify="space-around">
            <Col span={24}>
              <Item label={<Text>Tenure & EMI Details</Text>} colon={false}>
                <TenureTable
                  editable={editable}
                  onDataChange={handleFinanceData}
                  initialData={financerTenure}
                  emiRows={emiRows}
                  setEmiRows={setEmiRows}
                />
              </Item>
            </Col>
          </Row>
        </>
      )}
    </Form>
  );
};

const WrappedPaymentForm = Form.create({ name: "payment_form" })(PaymentForm);

export default WrappedPaymentForm;